// Types
import { BookingSummary } from '@/services/BookingService.interface'
import { Lihe } from '@/services/CatalogService.interface'
// Configurations and Enums
import { PrestType } from '@/config'
class BookingDataMapper {
  /**
   * Assign liheImages to bookings based on their liheId
   * @param {BookingSummary[]} bookings - Array of booking objects
   * @param {Lihe[]} lihes - Array of Lihe objects
   * @returns {BookingSummary[]} - Updated bookings with liheImages
   */
  public static assignLiheImages(
    bookings: BookingSummary[],
    lihes: Lihe[]
  ): BookingSummary[] {
    return bookings.map(booking => {
      const lihe = lihes.find(l => l.liheId === booking.liheId)
      return {
        ...booking,
        image: lihe?.liheImages?.[0]?.imagePath || null, // Assign the first image or null
      }
    })
  }

  /**
   * Overwrite prestation names in bookings based on PrestTypeId = 1
   * @param {BookingSummary[]} bookings - Array of booking objects
   * @param {Lihe[]} lihes - Array of Lihe objects
   * @returns {BookingSummary[]} - Updated bookings with overwritten prestation names
   */
  public static overwritePrestationName(
    bookings: BookingSummary[],
    lihes: Lihe[]
  ): BookingSummary[] {
    return bookings.map(booking => {

      const lihe = lihes.find(l => l.liheId === booking.liheId)

      if (!lihe) {

        // Attempt to shorten option names using liheName if available
        booking.options = booking.options.map(option => {
          // Handle null/undefined option names
          if (!option.name) {
            option.name = 'Unknown Service' // Provide fallback
            return option
          }
          
          if (booking.liheName && option.name.includes(booking.liheName)) {
            option.name = option.name.replace(`${booking.liheName} - `, '')
          }
          return option
        })

        return booking // Return updated booking after processing options
      }


      booking.options = booking.options.map(option => {


        if (option.prestTypeId === PrestType.Accomodation) {
          const matchingPrest = lihe.prests.find(
            p => p.prestId === option.prestId
          )

          if (matchingPrest && matchingPrest.accomodationName?.trim()) {
            option.name = matchingPrest.accomodationName // Overwrite the name only if it's defined and not empty
          } else {
            console.warn(
              `No valid accomodationName found for prestId: ${option.prestId} in Lihe:`,
              lihe
            )
          }
        }

        return option
      })

      return booking
    })
  }
}

export default BookingDataMapper
